import Module, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import PlayerIconView from "./playerIcon_view";
import PlayerIconModule from "./playerIcon";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import GameServer from "../../server/gameserver/game_server";
import ChatInfo from "../../../table/module/tablechat/chatinfo";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("PlayerInfoModule")
export class PlayerInfoModule extends ChatInfo {
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.viewType = PlayerIconView;
        this.needDeferShow = true
        this.initModule(false,false,false)
    }

    onInit(){
        super.onInit()
    }
}
